export default __webpack_public_path__ + "static/tantrum-aff4a5782f0d9dde3b78c22f70a799f1.svg";